import { render, staticRenderFns } from "./busqueda-institucion.vue?vue&type=template&id=c34a6db8&"
import script from "./busqueda-institucion.component.ts?vue&type=script&lang=ts&"
export * from "./busqueda-institucion.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports